import slugify from '@sindresorhus/slugify';

(function ($, Drupal, once) {
  Drupal.behaviors.enap_toc = {
    attach: function (context, settings) {
      var theme = settings['ajaxPageState']['theme']
      var blockClass = `.block--${theme}-content`
      once('enap-toc', blockClass, context).forEach(function (element) {
        const $titles = $('h2:not([data-toc-title])', element)
        $titles.each(function () {
          if (!$(this).attr('id')) {
            $(this).attr('id', slugify($(this).text()))
          }
          $('#enap-toc ol', element).append('<li><a href="#' + $(this).attr('id') + '"><span class="icon-arrow-down"></span> ' + $(this).text() + '</a></li>')
        })
      })

    }
  };
})(jQuery, Drupal, once);
